import { gsap, ScrollTrigger } from "@gsap";

document.addEventListener("DOMContentLoaded", function () {
	gsap.registerPlugin(ScrollTrigger);

	const shapes = document.querySelectorAll(".shape-video");

	shapes.forEach((shape) => {
		const init = () => {
			if (shape.dataset.scrubInit) return;
			shape.dataset.scrubInit = "1";
			shape.pause();
			shape.currentTime = 0;

			const proxy = { time: 0 };

			gsap.to(proxy, {
				time: shape.duration,
				ease: "none",
				onUpdate: () => {
					// Skip while a seek is pending so seeks don't pile up
					if (!shape.seeking) shape.currentTime = proxy.time;
				},
				scrollTrigger: {
					trigger: shape,
					start: "top bottom",
					end: "bottom top",
					scrub: 1,
					markers: false
				},
			});
		};

		if (shape.readyState >= 1) {
			init();
		} else {
			shape.addEventListener("loadedmetadata", init, { once: true });
			shape.load();
		}
	});
});